import type { FaireProductEntity } from "../../entity_types/product";

export const p_ugh8ue7mhe: FaireProductEntity = {
  token: "p_ugh8ue7mhe",
  type: "product",
  name: "Crystal Fantasy™ - Buddha",
  brandToken: "b_66wf2igxcf",
  brandName: "Woodstock Chimes",
  imageUrl:
    "https://cdn.faire.com/fastly/5bf06d8b245bd2ac61fea5c7e67e02f28b3eefc47354dd075253b78908f520fb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7a2eaa86330be70ca1b2364e0c35e6ff5bb26db7a2010f09f21547368edbe2e8.jpeg",
    "https://cdn.faire.com/fastly/3897f8e60243c7cd7e381d41c8117780a0af8a773ff282a8771c6a3639e9ac60.jpeg",
    "https://cdn.faire.com/fastly/19ef00d349de9b01556946e1824f5a65656f068b77cb203a45348b152b0186d8.jpeg",
  ],
  priceDollars: 18.01,
  description:
    "A large crystal is topped by smaller crystals and a silver seated Buddha.\n\nThe serene Buddha tops a cluster of crystals that sparkle and shine in the sun.",
  tags: [],
  msrpDollars: 36.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:23.019Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
